module.exports = __webpack_public_path__ + "assets/images/project/map-logo-svg/mobile.svg?v=97fd17b8";